<template>
  <v-list-group v-if="routeShow(item)"
                :key="Math.random()"
                v-bind="mdiIcon(item)"
                v-model="item.meta.active"
                @click="item.meta.active = !item.meta.active"
                no-action
  >
    <template v-slot:activator>
      <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
    </template>

    <template v-for="(children, index) in item.children">

      <v-list-item v-if="routeSchema(children) && routeShow(children)"

                   :to="{ name: children.name }"
                   :key="index"
                   link
      >
        <v-list-item-title>
          {{ children.meta.title }}
        </v-list-item-title>

        <v-list-item-action>
          <v-icon>{{ children.meta.icon }}</v-icon>
        </v-list-item-action>

      </v-list-item>
      <template v-else>
        <ListGroup :item="children"/>
      </template>
    </template>
  </v-list-group>
</template>

<script>

export default {
  props: {
    item: Object
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const child = this.item.children
        const route = child?.find(ch => ch.name === to.name)
        if (route) {
          this.item.meta.active = true
        }
      }
    }
  },
  components: {
    ListGroup: () => import('@/components/pageUnits/ListGroup')
  },
  methods: {
    mdiIcon(item) {
      const sub = !!item.meta.subGroup
      if (sub) {
        return {
          "sub-group": !!item.meta.subGroup,
          "prepend-icon": 'mdi-chevron-up',
        }
      }
      return {
        "prepend-icon": item.meta.icon || 'mdi-chevron-up',
      }
    },
  }
}
</script>
